import type { GetPaymentPageUnauthenticated } from '@/lib/cloudFunctions';
import { getPaymentPageUnauthenticated } from '@/lib/cloudFunctions';
import type { HasSideEffect } from '@/util/reducerWithSideEffects';

export type PaymentPageState = BasePaymentPageState &
  HasSideEffect<PaymentPageAction>;

type BasePaymentPageState =
  | { name: 'UNKNOWN' }
  | { name: 'PAGE_ID_MISSING' }
  | { name: 'PAGE_INFO_LOADING' }
  | { name: 'PAGE_INFO_LOAD_ERROR'; error: string }
  | { name: 'PAGE_EXPIRED' }
  | {
      name: 'PAGE_INFO_LOADED';
      info: GetPaymentPageUnauthenticated.SuccessPayload;
    };

export type PaymentPageAction =
  | { type: 'PAGE_ID_CHANGED'; pageId: string | undefined }
  | {
      type: 'PAGE_INFO_LOADED';
      info: GetPaymentPageUnauthenticated.SuccessPayload;
    }
  | { type: 'PAGE_INFO_LOAD_ERROR'; error: string }
  | { type: 'PAGE_EXPIRED' };

export const initialState: PaymentPageState = {
  name: 'UNKNOWN',
};

export const paymentPageReducer = (
  _: PaymentPageState,
  action: PaymentPageAction,
): PaymentPageState => {
  switch (action.type) {
    case 'PAGE_ID_CHANGED': {
      if (!action.pageId) {
        return {
          name: 'PAGE_ID_MISSING',
        };
      }
      const pageId = action.pageId;
      return {
        name: 'PAGE_INFO_LOADING',
        sideEffect: async (dispatch) => {
          try {
            const result = await getPaymentPageUnauthenticated({
              paymentPageId: pageId,
            });
            if (result.status === 'success') {
              if (
                !result.payload.availablePaymentMethods.ach &&
                !result.payload.availablePaymentMethods.creditCard
              ) {
                dispatch({
                  type: 'PAGE_INFO_LOAD_ERROR',
                  error: 'No payment types supported',
                });
              } else {
                dispatch({ type: 'PAGE_INFO_LOADED', info: result.payload });
              }
            } else if (result.status === 'pageExpired') {
              dispatch({ type: 'PAGE_EXPIRED' });
            } else {
              dispatch({
                type: 'PAGE_INFO_LOAD_ERROR',
                error: result.error,
              });
            }
          } catch (err) {
            dispatch({
              type: 'PAGE_INFO_LOAD_ERROR',
              error:
                err instanceof Error
                  ? err.message
                  : 'An unknown error occurred',
            });
          }
        },
      };
    }
    case 'PAGE_INFO_LOADED':
      return {
        name: 'PAGE_INFO_LOADED',
        info: action.info,
      };
    case 'PAGE_INFO_LOAD_ERROR':
      return {
        name: 'PAGE_INFO_LOAD_ERROR',
        error: action.error,
      };
    case 'PAGE_EXPIRED':
      return {
        name: 'PAGE_EXPIRED',
      };
  }
};
